// Regex
export const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/

export const fractalIdRegex = /^\d{1,12}$/

export const requiredPT = value => value
  ? undefined
  : 'Campo Obrigatório'

export const requiredES = value => value
  ? undefined
  : 'Campo Obligatorio'

export const taxpayerValidation = value => String(value ?? '').replace(/[-.]/g, '').length === 11
  ? undefined
  : 'CPF deve ter 11 digitos'

export const phoneValidationBR = value => {
  return String(value ?? '').replace(/[-.()\s]/g, '').length >= 10
    ? undefined
    : 'Insira um número de telefone com 10 ou 11 digitos'
}

export const phoneValidationPAR = value => {
  const formattedValue = String(value ?? '').replace(/[-.()\s]/g, '')
  return (formattedValue.length >= 8 && formattedValue.length <= 10)
    ? undefined
    : 'Ingresa un número de teléfono de 8 a 10 digitos'
}

export const fullnameLengthPT = value => String(value ?? '').length >= 3
  ? undefined
  : 'Este campo deve ter no mínimo 3 caracteres'

export const fullnameLengthES = value => String(value ?? '').length >= 3
  ? undefined
  : 'Este campo debe tener al menos 3 caracteres.'

export const validFullnamePT = value => /^[a-zA-ZéúíóáÉÚÍÓÁèùìòàçÇÈÙÌÒÀõãñÕÃÑêûîôâÊÛÎÔÂëÿüïöäËYÜÏÖÄ\-' \s]+$/.test(value)
  ? undefined
  : 'Um nome completo válido deve ter ao menos um nome e sobrenome'
export const validFullnameES = value => /^[a-zA-ZéúíóáÉÚÍÓÁèùìòàçÇÈÙÌÒÀõãñÕÃÑêûîôâÊÛÎÔÂëÿüïöäËYÜÏÖÄ\-' \s]+$/.test(value)
  ? undefined
  : 'Un nombre completo y válido debe tener al menos un nombre y apellido.'

export const passwordConfirmationPT = getValues => value => value === getValues('password')
  ? undefined
  : 'A confirmação deve ser igual à senha'
export const passwordConfirmationES = getValues => value => value === getValues('password')
  ? undefined
  : 'La confirmación debe coincidir con la contraseña.'

export const passwordLengthPT = value => String(value ?? '').length >= 6
  ? undefined
  : 'A senha deve ter no mínimo 6 caracteres'
export const passwordLengthES = value => String(value ?? '').length >= 6
  ? undefined
  : 'La contraseña debe tener al menos 6 caracteres'

export const emailPT = value => emailRegex.test(value)
  ? undefined
  : 'Insira um E-mail válido'
export const emailES = value => emailRegex.test(value)
  ? undefined
  : 'Introduzca un correo electrónico válido.'

export const fractalIdPT = value => fractalIdRegex.test(value)
  ? undefined
  : 'Insira um Fractal ID válido'
export const fractalIdES = value => fractalIdRegex.test(value)
  ? undefined
  : 'Introduzca un Fractal ID válido'

export const emailOrFractalIdPT = value => emailRegex.test(value) || fractalIdRegex.test(value)
  ? undefined
  : 'Entre com um E-mail ou Fractal ID'
export const emailOrFractalIdES = value => emailRegex.test(value) || fractalIdRegex.test(value)
  ? undefined
  : 'Ingrese un E-mail o Fractal ID'

export const noSpecialCharsPT = value => !/[^A-Za-zÀ-Úà-ú'\- ]/.test(value)
  ? undefined
  : 'Não são permitidos números ou caracteres especiais'
export const noSpecialCharsES = value => !/[^A-Za-zÀ-Úà-ú'\- ]/.test(value)
  ? undefined
  : 'No se permiten números ni caracteres especiales.'

export const emailToLowerCase = (value) => {
  if (!value) {
    return value
  }
  return value.toLowerCase()
}

export const composeValidators = (...validators) => value => {
  for (const validate of validators) {
    const error = validate(value)
    if (error) {
      return error
    }
  }
  return undefined
}
